__turbopack_context__.v({
  "dotlarge": "Footer-module__rnk_JG__dotlarge",
  "footer": "Footer-module__rnk_JG__footer",
  "footercontent": "Footer-module__rnk_JG__footercontent",
  "footerheading": "Footer-module__rnk_JG__footerheading",
  "footerimg1": "Footer-module__rnk_JG__footerimg1",
  "footerimg2": "Footer-module__rnk_JG__footerimg2",
  "googleplay": "Footer-module__rnk_JG__googleplay",
  "img": "Footer-module__rnk_JG__img",
  "listcontent": "Footer-module__rnk_JG__listcontent",
  "mobilenum": "Footer-module__rnk_JG__mobilenum",
});
